export const BASE_URL = "http://localhost:8080/api/v1"; // please change your base url here but never commit it if its different from port 8080 because it is the standard
 
export const GENDER_OPTIONS = [
    {id: 0, name: "Male"},
    {id: 1, name: "Female"},
    {id: 2, name: "Rather Not Say"},
 ] 